import React from 'react';
import WebsiteNavbar from '../../components/WebsiteUI/WebsiteNavbar';
import WebsiteFooter from '../../components/WebsiteUI/WebsiteFooter';
import CTASection from '../../components/WebsiteUI/CTASection';
import HeroSection from './HeroSection';
import FeaturesSection from './FeaturesSection';
import TestimonialsSection from './TestimonialsSection';

const LandingPage = () => {
  return (
    <>
      <WebsiteNavbar />
      <HeroSection />
      <FeaturesSection />
      <TestimonialsSection />
      <CTASection />
      <WebsiteFooter />
    </>
  );
};

export default LandingPage;
